<template>
  <div class="wrong-answer-card">
    <div class="wrong-header">
      <div class="wrong-icon">
        <i class="el-icon-circle-close" style="font-weight: bold; color: #F56C6C;"></i>
        <span style="color: #F56C6C;">Incorrectly Answered Card</span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="wrong-actions">
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="remove">
              <i class="el-icon-delete"></i> Remove
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="wrong-content">
      <div class="answer-preview">
        <div class="answer-content" @click="viewPost">
          <div v-if="wrongAnswer.answer_card.content_type === 'text'" v-html="wrongAnswer.answer_card.content"></div>
          <div v-else-if="wrongAnswer.answer_card.content_type === 'image'" class="image-content">
            <img v-if="wrongAnswer.answer_card.fileList && wrongAnswer.answer_card.fileList.length > 0" :src="wrongAnswer.answer_card.fileList[0].url" alt="Wrong answer image" style="max-width: 100%; height: auto; border-radius: 4px;">
          </div>
          <div v-else-if="wrongAnswer.answer_card.content_type === 'video'" class="video-content">
            <video v-if="wrongAnswer.answer_card.fileList && wrongAnswer.answer_card.fileList.length > 0" controls style="max-width: 100%; height: auto; border-radius: 4px;">
              <source :src="wrongAnswer.answer_card.fileList[0].url" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else-if="wrongAnswer.answer_card.content_type === 'quiz'" class="quiz-content">
            <p class="quiz-question"><strong>Question:</strong> {{ wrongAnswer.answer_card.quiz_content.question }}</p>
            <div
              v-for="(option, idx) in wrongAnswer.answer_card.quiz_content.options.filter(opt => opt !== '')"
              :key="idx"
              class="quiz-option"
              :class="{
                'correct': ['A','B','C','D'][idx] === wrongAnswer.answer_card.quiz_content.correct_answer,
                'incorrect': (wrongAnswer.answer || wrongAnswer.user_answer) && ['A','B','C','D'][idx] === (wrongAnswer.answer || wrongAnswer.user_answer) && (wrongAnswer.answer || wrongAnswer.user_answer) !== wrongAnswer.answer_card.quiz_content.correct_answer
              }"
            >
              <div class="quiz-option-content">
                <div style="display: flex; flex: 1; align-items: flex-start;">
                  <span style="min-width: 30px; line-height: 1.5;">{{ ['A','B','C','D'][idx] }}.</span>
                  <span style="line-height: 1.5;">{{ option }}</span>
                </div>
                <span
                  v-if="['A','B','C','D'][idx] === wrongAnswer.answer_card.quiz_content.correct_answer"
                  class="el-icon-check correct-marker"
                ></span>
                <span
                  v-if="(wrongAnswer.answer || wrongAnswer.user_answer) && ['A','B','C','D'][idx] === (wrongAnswer.answer || wrongAnswer.user_answer) && (wrongAnswer.answer || wrongAnswer.user_answer) !== wrongAnswer.answer_card.quiz_content.correct_answer"
                  class="el-icon-close incorrect-marker"
                ></span>
              </div>
            </div>
          </div>
          <div v-else>
            <p>{{ wrongAnswer.answer_card.content }}</p>
          </div>
        </div>

      </div>

      <div class="post-info-section">
        <div class="stack-header">
          <div class="stack-header-left">
            <span class="stack-label">From the stack</span>
            <span class="dot">•</span>
            <span class="author-wrapper">
              <span class="author-label">by</span>
              <el-avatar :size="16" class="author-avatar" style="font-size: 10px;">{{ wrongAnswer.answer_card.author?.charAt(0) || 'U' }}</el-avatar>
              <span class="author-name">{{ wrongAnswer.answer_card.author }}</span>
            </span>
            <span class="dot">•</span>
            <span class="answer-index">Card #{{ wrongAnswer.answer_card.answerIndex + 1 }}</span>
          </div>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-view"
            @click="viewPost"
            class="view-btn"
          >
            View the Stack
          </el-button>
        </div>
        <div class="post-info-content">
          <h3 class="post-info-title" @click="viewPost">{{ wrongAnswer.answer_card.postTitle }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WrongAnswerCard',
  props: {
    wrongAnswer: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimestamp() {
      const date = new Date(this.wrongAnswer.timestamp || this.wrongAnswer.create_time * 1000)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))

      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else {
        const diffInDays = Math.floor(diffInHours / 24)
        if (diffInDays <= 10) {
          return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
        } else {
          const month = date.toLocaleString('en-US', { month: 'short' })
          const day = date.getDate()
          const year = date.getFullYear()
          const currentYear = now.getFullYear()

          if (year === currentYear) {
            return `${month} ${day}`
          } else {
            return `${month} ${day}, ${year}`
          }
        }
      }
    }
  },
  methods: {
    viewPost() {
      // Navigate to post detail page with card index
      this.$router.push({
        path: '/stack',
        query: {
          id: this.wrongAnswer.answer_card.postId,
          cardIndex: this.wrongAnswer.answer_card.answerIndex
        }
      })
    },
    handleCommand(command) {
      if (command === 'remove') {
        this.$emit('remove', this.wrongAnswer._id?.$oid || this.wrongAnswer._id?.$id || this.wrongAnswer.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrong-answer-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #F56C6C;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.wrong-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.wrong-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #F56C6C;
  }

  > span {
    font-weight: 600;
    color: #F56C6C;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.wrong-actions {
  display: flex;
  gap: 8px;

  .view-btn {
    color: #1159AF;
    font-size: 12px;

    &:hover {
      color: #409EFF;
    }
  }

  .remove-btn {
    color: #6c757d;
    font-size: 12px;

    &:hover {
      color: #dc3545;
    }
  }
}

.wrong-content {
  .post-info-section {
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin-top: 16px;

    .stack-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #dee2e6;

      .stack-header-left {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;

        .stack-label {
          font-size: 12px;
          font-weight: 600;
          color: #6c757d;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .dot {
          color: #adb5bd;
          font-size: 12px;
        }

        .author-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          color: #6c757d;

          .author-label {
            font-size: 12px;
          }

          .author-avatar {
            flex-shrink: 0;
          }

          .author-name {
            font-size: 12px;
          }
        }

        .answer-index {
          background-color: #fff;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
          font-size: 12px;
          color: #6c757d;
        }
      }

      .view-btn {
        color: #1159AF;
        font-size: 12px;
        flex-shrink: 0;

        &:hover {
          color: #409EFF;
        }
      }
    }

    .post-info-content {
      .post-info-title {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
        margin: 0 0 8px 0;
        cursor: pointer;
        line-height: 1.4;

        &:hover {
          color: #1159AF;
        }
      }
    }
  }

  .answer-preview {
    .answer-content {
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 14px;
      color: #495057;
      line-height: 1.6;

      &:hover {
        color: #2c3e50;
      }
    }

    .quiz-content {
      .quiz-question {
        font-weight: 600;
        margin-bottom: 16px;
      }

      .quiz-option {
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 12px 20px;
        margin-bottom: 12px;
        margin-top: 12px;
        transition: all 0.3s ease;
        background-color: #FFFFFF;

        &.correct {
          background-color: #f0f9ff;
          border-color: #67c23a;
        }

        &.incorrect {
          background-color: #fef0f0;
          border-color: #F56C6C;
        }
      }

      .quiz-option-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .correct-marker {
        color: #67c23a;
        font-size: 20px;
        font-weight: bold;
      }

      .incorrect-marker {
        color: #F56C6C;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}
</style>
